import React from 'react';

import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

import { Loading } from '../Loading';

import { DeereCachedFetch } from '../../shared/fetch';

let identifier = 0;
export function CountrySelect({ countries, loading, onChange, ...props }) {
    const [id, setID] = React.useState();
    const [_countries, setCountries] = React.useState([]);

    React.useEffect(() => {
        setID(identifier++);
        DeereCachedFetch('/api/countries', {
            cacheDuration: 'forever'
        }).then((activeCountries) => {
            setCountries(Object.entries(activeCountries).map(([key, value]) => ({
                value: key,
                label: value
            })).concat(countries.filter((country) => !activeCountries[country]).map((country) => ({
                value: country,
                label: country
            }))));
        });
    }, []);

    return (
        <Loading {...props} loading={loading}>
            <FormControl style={{ minWidth: 320, marginRight: '10px' }} variant="outlined">
                <InputLabel htmlFor={`countries-${id}`}>Countries</InputLabel>
                <Select disabled={loading}
                    inputProps={{
                        name: 'countries',
                        id: `countries-${id}`
                    }}
                    labelWidth={65}
                    multiple
                    onChange={async ({ target }) => onChange(target.value)}
                    style={{ maxHeight: '2.5em' }}
                    value={countries}>
                    {_countries.map((country) => (
                        <MenuItem key={country.value} value={country.value}>{country.label}</MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Loading>
    );
}
